import { useMutation } from '@tanstack/react-query';

import { requestPhoneCode, confirmPhoneCode, cancelPendingPhone } from '../services/phone-verification.service';

export function useRequestPhoneCode() {
  return useMutation({ mutationFn: (phone: string) => requestPhoneCode(phone) });
}

export function useConfirmPhoneCode() {
  return useMutation({ mutationFn: (code: string) => confirmPhoneCode(code) });
}

export function useCancelPendingPhone() {
  return useMutation({ mutationFn: () => cancelPendingPhone() });
}
